module.exports = __webpack_public_path__ + "static/media/slider-discount.2655208f.svg";